"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Standards() {
  const line1 = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const line2 = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const line3 = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const support = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.1
  });
  const actions = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const headlineLines = [{
    text: "Elevating professional",
    reveal: line1,
    delay: "0ms"
  }, {
    text: "standards for",
    reveal: line2,
    delay: "80ms"
  }, {
    text: "discerning clients.",
    reveal: line3,
    delay: "160ms"
  }];
  return <section data-section-id="15244" id="elevating-professional-standards" className="bg-background text-foreground relative w-full min-h-[92vh] flex items-end py-32 md:py-44 px-6 md:px-12 overflow-hidden">
      <div className="w-full max-w-[1440px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-x-6 gap-y-16 lg:gap-y-0 w-full">
          {}
          <div className="lg:col-span-9 flex flex-col">
            <h1 className="font-default font-medium text-foreground leading-[0.92] tracking-tight" style={{
            fontSize: "clamp(2.5rem, 8vw, 7.5rem)",
            letterSpacing: "-0.025em"
          }}>
              {headlineLines.map((line, i) => <span key={i} data-index={i} className="block overflow-hidden">
                  <span ref={line.reveal.ref} className="block transition-transform duration-[520ms] ease-[cubic-bezier(0.2,0,0,1)] will-change-transform" style={{
                transform: line.reveal.isVisible ? "translateY(0)" : "translateY(100%)",
                transitionDelay: line.delay
              }}>
                    {line.text}
                  </span>
                </span>)}
            </h1>

            <p ref={support.ref} className="font-default text-foreground/85 mt-16 md:mt-24 max-w-2xl transition-all duration-[480ms] ease-[cubic-bezier(0.2,0,0,1)]" style={{
            fontSize: "clamp(1.0625rem, 1.3vw, 1.375rem)",
            lineHeight: 1.45,
            letterSpacing: "-0.005em",
            opacity: support.isVisible ? 1 : 0,
            transform: support.isVisible ? "translateY(0)" : "translateY(16px)",
            transitionDelay: "640ms"
          }}>
              {"Consulting, project management, and tailored expertise engineered for long-term success."}
            </p>
          </div>

          {}
          <div className="lg:col-span-3 flex items-end">
            <div ref={actions.ref} className="flex flex-col gap-4 lg:items-start w-full transition-all duration-[480ms] ease-[cubic-bezier(0.2,0,0,1)]" style={{
            opacity: actions.isVisible ? 1 : 0,
            transform: actions.isVisible ? "translateY(0)" : "translateY(16px)",
            transitionDelay: "780ms"
          }}>
              <Button asChild size="lg" className="font-default bg-primary text-primary-foreground hover:bg-primary/90 px-8 py-4 h-auto text-base font-medium tracking-normal w-full sm:w-auto">
                <Link to="/ConnectPage">Start a consultation</Link>
              </Button>

              <Link to="/OurExpertisePage" className="group font-default text-foreground text-base font-medium inline-flex items-center w-fit transition-colors duration-[180ms] hover:text-primary">
                <span className="border-b border-foreground pb-1.5 group-hover:border-primary group-hover:border-b-2 transition-all duration-[180ms]">
                  Explore our expertise
                </span>
              </Link>
            </div>
          </div>
        </div>

        {}
        <div className="absolute left-6 right-6 md:left-12 md:right-12 bottom-8 h-px bg-border" />
      </div>
    </section>;
}